import { createSelector } from 'reselect'

import { initialState, ProfileReducer } from '../reducers/domain'

const getProfile = (state: { profile: ProfileReducer }) => (state.profile && state.profile.data) || initialState.data

export default createSelector(getProfile, (profile) => profile.deliveryOption)
